<div class="modal-main create-user" [formGroup]="formGroup">
  <ng-template #backButtonRef>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </ng-template>
  <app-access-point-activity-detail
    class="d-none"
    [class.d-block]="stepper === 1"
    [isProfileActivityFilter]="isProfileActivityFilter"
    [dialogRef]="dialogRef"
    [(stepper)]="stepper"
    (submitToParent)="submitToParent()"
    (resetFilterData)="resetFilterData()"
  >
    <span backButton>
      <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
    </span>
  </app-access-point-activity-detail>

  <ng-container *ngIf="stepper === 2">
    <app-user-name
      formGroupName="userName"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-name>
  </ng-container>

  <ng-container *ngIf="stepper === 3">
    <app-lock-types
      formGroupName="locks"
      formGroupIdName="lockIds"
      [activityTypes]="activityTypes"
      [entityType]="filterActivity.entityType"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-lock-types>
  </ng-container>

  <ng-container *ngIf="stepper === 4">
    <app-date-range
      formGroupName="dateRange"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-date-range>
  </ng-container>
</div>
